import UnifiedPlayer from '@tv2-player/unifiedplayer/src/core/UnifiedPlayer';
// eslint-disable-next-line monorepo-dependencies/no-unlisted-package-import
import type { PlayerManager } from 'chromecast-caf-receiver/cast.framework';
import { Subscription } from 'rxjs';
import { bootstrapAction, playerFilter } from '../extensions';
import updateMediaInformationHandler from '../../handlers/mediaInformation';

export class MetadataPlugin {
  player: UnifiedPlayer;
  playerManager: PlayerManager;
  subscription: Subscription;

  init() {
    playerFilter.register(async player => {
      this.player = player;
      this.subscription?.unsubscribe();
      this.subscription = updateMediaInformationHandler(this.player!, this.playerManager).subscribe(
        mediaInformation => {
          this.playerManager.setMediaInformation(mediaInformation);
        }
      );
      return player;
    });
    bootstrapAction.register(async context => {
      this.playerManager = context.getPlayerManager();
    });
  }
}
